const storeErrorHandler = (error) => {
    try {
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('StoreError', {
                detail: error,
            }));
        }
    } catch {
        //
    }
};

export default storeErrorHandler;
